// extracted by mini-css-extract-plugin
module.exports = {"favoriteWrapper":"FavoriteIcon_favoriteWrapper__1rCgC","inWishlist":"FavoriteIcon_inWishlist__2x4Ik"};